export default "__VITE_ASSET__CNHp2WkP__"